import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GenericRepository } from "src/app/repositories/generic-repository/GenericRepository";
import { ProductionEntry, ProductionQCUpdateModel } from "src/app/models/Production/ProductionEntry";
import { IProductionEntryRepository } from "./IProductionEntryRepository";

@Injectable({
  providedIn: 'root'
})
export class ProductionEntryRepository
  extends GenericRepository<ProductionEntry>
  implements IProductionEntryRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/productionEntries', environment.urlAddress);
  }

  GetAll(
    currentPage: number,
    recordsPerPage: number,
    filterText: string,
    companyId?: number | null,
    marketId?: number | null,
    productId?: number | null,
    productionDate?: string | null,
    productCode?: string | null
  ): Observable<any> {

    filterText = filterText ? filterText.split('/').join('~') : "";
    
    let url = 'SelectAll/' + currentPage + '/' + recordsPerPage + '/' + (filterText || "");
    
    let queryParams = [];
    
    if (companyId) {
      queryParams.push(`companyId=${companyId}`);
    }
    if (marketId) {
      queryParams.push(`marketId=${marketId}`);
    }
    if (productId) {
      queryParams.push(`productId=${productId}`);
    }
    if (productionDate) {
      queryParams.push(`productionDate=${productionDate}`);
    }
    if (productCode) {
      queryParams.push(`productCode=${encodeURIComponent(productCode)}`);
    }
    
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }
    
    return this.Get(url);
  }

  Select(id: number): Observable<any> {
    return this.Get('Select/' + id);
  }

  GetRejectionReasons(): Observable<any> {
    return this.Get('RejectionReasons');
  }

  UpdateQCStatus(model: ProductionQCUpdateModel): Observable<any> {
    return this.PostData('/UpdateQCStatus', model as any);
  }
}